interface SearchResultState {
  enableGrayScale?: boolean;
}

export default SearchResultState;

export const initialState: SearchResultState = {
  enableGrayScale: false
};
